/* eslint-disable react/jsx-filename-extension */
import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import Router from '../../catalog/Router';
import { Navigation } from '../../catalog/Nav';
import SetFavicons from '../../catalog/SetFavicons';
import Favicon from './favicon.png';
import Header from './Header';
import Footer from './Footer';
import LandingPage from './LandingPage';
import SupernovaPopup from '../../catalog/SupernovaPopup';

import './App.css';

export default function App(props) {
  const title = 'Seating by OnePointe Solutions';
  const catalog = 'partner';
  const partner = 'onepointe';
  const logoURL = 'https://ecomseating.s3.amazonaws.com/images/other/onepointe-logo.png';
  const buildAChair = 'Hs34cfOP';
  const extraAttributes = {
    trackId: 'G-N7SGWHN66T',
  };
  ReactGA.initialize(extraAttributes.trackId);
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }, []);

  document.title = title;
  document.partner = partner;
  document.catalog = catalog;
  document.buildAChair = buildAChair;

  useEffect(() => {
    SetFavicons(Favicon);
  });

  return (
    <div>
      <SupernovaPopup
        host="https://chairs.onepointesolutions.com"
        backgroundColor="rgba(31, 118, 226, 0.95)"
        textColor="white"
      />
      <header className="filter-bound-top">
        <Header />
      </header>
      <div
        className="center-container"
        style={{ maxWidth: '1300px', margin: 'auto', marginTop: '180px' }}
      >
        <div>
          <Navigation partner={partner} url={logoURL} />
        </div>
        <Router
          partner={partner}
          catalog={catalog}
          orderButtonType="rfq"
          logoURL={logoURL}
          home={<LandingPage />}
          extraAttributes={extraAttributes}
        />
      </div>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}
